import dayjs from 'dayjs';
import { TemplateChecklistTask, TemplateSchema } from '@ametista-ai/api-schema';

export type ChecklistPreviewTask = {
  id: string;
  title: string;
  userId: string | null;
  dueDate: Date | null;
  blockedBy?: string[];
  blockedByPostApproval?: boolean;
  dueDateOffsetDays: number;
  dueDateOffsetTime: string | null;
  /** True once the user edits this task's due date by hand, so a post-date change won't overwrite it. */
  manualDueDate: boolean;
};

function computeDueDate(postDate: dayjs.Dayjs, task: TemplateChecklistTask): Date {
  let dueDate = postDate.add(task.dueDateOffsetDays ?? 0, 'day');
  if (task.dueDateOffsetTime) {
    const [hours, minutes] = task.dueDateOffsetTime.split(':').map(Number);
    if (!Number.isNaN(hours) && !Number.isNaN(minutes)) {
      dueDate = dueDate.hour(hours).minute(minutes).second(0).millisecond(0);
    }
  }
  return dueDate.toDate();
}

export function buildChecklistPreview(
  template: TemplateSchema | undefined,
  postDate: dayjs.Dayjs
): ChecklistPreviewTask[] {
  return (template?.checklist ?? []).map((task) => ({
    id: task.id,
    title: task.label,
    userId: task.userId || null,
    blockedBy: task.blockedBy,
    blockedByPostApproval: task.blockedByPostApproval,
    dueDateOffsetDays: task.dueDateOffsetDays ?? 0,
    dueDateOffsetTime: task.dueDateOffsetTime ?? null,
    dueDate: computeDueDate(postDate, task),
    manualDueDate: false,
  }));
}

export function recomputeChecklistDueDates(
  tasks: ChecklistPreviewTask[],
  postDate: dayjs.Dayjs
): ChecklistPreviewTask[] {
  return tasks.map((task) =>
    task.manualDueDate
      ? task
      : {
          ...task,
          dueDate: computeDueDate(postDate, {
            id: task.id,
            label: task.title,
            userId: task.userId ?? '',
            dueDateOffsetDays: task.dueDateOffsetDays,
            dueDateOffsetTime: task.dueDateOffsetTime,
          }),
        }
  );
}
